import { PropsWithChildren } from 'react';
import { SegmentHandler, useTrackLinks, useTrackPage } from '@repo/segment';
import { useLocation } from '@tanstack/react-router';
import styles from './AppLayout.module.css';

SegmentHandler.instance.init(import.meta.env.VITE_APP_SEGMENT_WRITE_KEY!);

export const AppLayout = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  useTrackLinks();
  useTrackPage([location.pathname]);
  return (
    <>
      <div className={styles.appWrapper}>
        <div className={styles.pageWrapper}>{children}</div>
      </div>
    </>
  );
};

export default AppLayout;
